module.exports = __webpack_public_path__ + "img/watch-back.8b53b670.svg";